<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Calculadora de presupuesto" titleLevel="h1">
              <template slot="partOne">Calculadora<br></template>
              <template slot="partTwo">de</template>
              <template slot="partThree"> presupuesto</template>
            </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Calculadora de presupuesto'" videoEmbed="ADMINISTRACIONDINERO22CalculadoraPresupuestoa (53).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-left">
          Ya conocimos cómo <strong>planificar</strong> una <strong>meta</strong>, comprendimos bien qué es un <strong>presupuesto</strong> y un <strong>flujo de efectivo</strong>,
              y también definimos los diferentes tipos de <strong>ingreso</strong>.<br><br>

              Ahora está listo para elaborar su propio presupuesto. Tan solo necesita dedicarle unos
              cuantos minutos y nosotros le facilitamos una poderosa herramienta que hará todo más sencillo:
              la <strong>calculadora de presupuesto</strong>.
        </p>
      </v-flex>
      <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="230" imaSrc="contenido/diapositiva_16" imaAlt="Mujer sonriendo con la mano en la cintura"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>


<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-22.vue?330b3b01